export const TODO_FORM_DATA_NOTES_DROPDOWN_PREFIX = 'todo-dropdown-notes-';
export const TODO_FORM_DATA_NOTES_TEXTAREA_PREFIX = 'todo-textarea-notes-';
